import Swiper, { Navigation } from 'swiper';

import {
    equalizeCardsContentHeight,
    fixAccessibilityRemoveIdsFromDuplicateSlides,
} from '../../../../../global/js/helpers';

function CardsA1() {
    Swiper.use([Navigation]);

    $('[data-module="cardsA1"]').each(function () {
        const module = $(this);
        const sliderEl = module.find('[data-slider]')[0];
        const $prevBtn = module.find('.js-slider-prev');
        const $nextBtn = module.find('.js-slider-next');
        const $navWrap = $prevBtn.closest('.o-cards-a-1__slider-nav');

        // Count only the real slides (exclude duplicated clones inserted by loop)
        const realSlides = module.find(
            '[data-slider] .swiper-slide:not(.swiper-slide-duplicate)',
        ).length;

        // Store Swiper instance for conditional init/destroy
        let swiperInstance = null;

        // Function to create the Swiper
        const createSwiper = () => {
            swiperInstance = new Swiper(sliderEl, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 16,
                lazy: true,
                breakpoints: {
                    1190: { spaceBetween: 24 },
                },
                navigation: {
                    prevEl: $prevBtn[0],
                    nextEl: $nextBtn[0],
                },
                on: {
                    init: function (e) {
                        equalizeCardsContentHeight(e);
                        setTimeout(
                            () =>
                                fixAccessibilityRemoveIdsFromDuplicateSlides(e),
                            1000,
                        );
                    },
                    resize: function (e) {
                        equalizeCardsContentHeight(e);
                    },
                },
            });

            // Update prev/next button disabled state on progress
            swiperInstance.on('progress', function (e, progress) {
                $prevBtn.toggleClass(
                    'a-btn-pagination--disabled',
                    progress <= 0,
                );
                $nextBtn.toggleClass(
                    'a-btn-pagination--disabled',
                    progress >= 1,
                );
            });

            // Initial disabled state
            $prevBtn.toggleClass(
                'a-btn-pagination--disabled',
                swiperInstance.isBeginning,
            );
            $nextBtn.toggleClass(
                'a-btn-pagination--disabled',
                swiperInstance.isEnd,
            );
        };

        // Handler for setting up or tearing down slider based on viewport and slide count
        const updateSlider = () => {
            const isDesktop = window.matchMedia('(min-width: 1190px)').matches;

            if (isDesktop && realSlides < 3) {
                // Desktop with too few slides: hide nav and destroy slider if initialized
                $navWrap.hide();
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                    swiperInstance = null;
                }
            } else {
                // Either mobile or desktop with enough slides: show nav and init slider if needed
                $navWrap.show();
                if (!swiperInstance) {
                    createSwiper();
                }
            }
        };

        // Initial check
        updateSlider();

        // Re-check on window resize
        window.addEventListener('resize', updateSlider);
    });
}

export default CardsA1;
